import { CandidatePriority, D_PRIORITIES, E_PRIORITIES, F_PRIORITIES } from '@pflegia/types/api/candidate/candidate-priority';
import { JobTitleCategory, JobTitleSpecification } from '@pflegia/types/api/job-title';

export const skipRecognitionFlow = (jtSpec?: JobTitleSpecification): boolean =>
  jtSpec?.category === JobTitleCategory.Companion ||
  (jtSpec?.category === JobTitleCategory.Praxia && D_PRIORITIES.includes(jtSpec?.jobTitle.trackingPriority)) ||
  [...E_PRIORITIES, ...F_PRIORITIES].includes(jtSpec?.jobTitle.trackingPriority as CandidatePriority);
